/** Small display helpers. Everything here is presentation-only. */

export function formatNumber(n: number | null | undefined): string {
  return (n ?? 0).toLocaleString()
}

/** "in 35m", "2h ago", "just now" — null-safe. */
export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return '—'

  const diff = then - Date.now()
  const future = diff > 0
  const abs = Math.abs(diff)

  const mins = Math.round(abs / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return future ? `in ${mins}m` : `${mins}m ago`

  const hours = Math.round(mins / 60)
  if (hours < 24) return future ? `in ${hours}h` : `${hours}h ago`

  const days = Math.round(hours / 24)
  if (days < 30) return future ? `in ${days}d` : `${days}d ago`

  return new Date(iso).toLocaleDateString()
}

/** "14 Mar, 09:14" */
export function shortDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** "09:14:02" — used in the log table where only the time matters. */
export function timeOnly(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleTimeString(undefined, { hour12: false })
}

export function initials(value: string | null | undefined): string {
  if (!value) return '?'
  const local = value.split('@')[0]
  const parts = local.split(/[.\-_ ]+/).filter(Boolean)
  const letters = parts.length > 1 ? parts[0][0] + parts[1][0] : local.slice(0, 2)
  return letters.toUpperCase()
}

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim())
}

export function truncate(s: string, max: number): string {
  return s.length <= max ? s : `${s.slice(0, max - 1)}…`
}
